export const MOBILE_PHYSICAL_TOPUP_FLOW = 'physical_service_topup';
export const MOBILE_PHYSICAL_TOPUP_PATH = '/user-top-up-account';
export const MOBILE_PHYSICAL_TOPUP_RETURN_URL = 'replayer://payment-complete';

const STORAGE_KEY = 'replayer:native-physical-topup';

const mobileSessionStorage = storage => {
  if (storage) return storage;
  return window.sessionStorage;
};

export const isSafeMobileSsoDestination = (path, flow) => {
  if (typeof path !== 'string') return false;
  if (/^\/club\/[A-Za-z0-9_-]+$/.test(path)) return !flow;
  return path === MOBILE_PHYSICAL_TOPUP_PATH && flow === MOBILE_PHYSICAL_TOPUP_FLOW;
};

export const markMobilePhysicalTopup = storage => {
  try {
    mobileSessionStorage(storage).setItem(STORAGE_KEY, '1');
    return true;
  } catch (error) {
    return false;
  }
};

export const hasMobilePhysicalTopup = storage => {
  try {
    return mobileSessionStorage(storage).getItem(STORAGE_KEY) === '1';
  } catch (error) {
    return false;
  }
};

export const clearMobilePhysicalTopup = storage => {
  try {
    mobileSessionStorage(storage).removeItem(STORAGE_KEY);
  } catch (error) {
    // Storage can be unavailable in private browsing; returning to the app still works.
  }
};
